import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, ArrowLeft, Home } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';

const NotFoundPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const goHome = () => {
    navigate(user ? '/groups' : '/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-6 py-16">
      <div className="flex flex-col items-center text-center gap-6 max-w-lg w-full">
        <div className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.4em] text-amber-300">
          <ShieldAlert className="w-5 h-5" />
          MYKLUBB
        </div>

        <div className="space-y-3">
          <p className="text-5xl font-semibold">404</p>
          <h1 className="text-3xl font-semibold">No encontramos esta página</h1>
          <p className="text-gray-400 text-base leading-relaxed">
            El enlace pudo estar roto o ya no existe. También es posible que no cuentes con permisos
            para acceder a esta sección.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 w-full max-w-md">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="flex-1 inline-flex items-center justify-center gap-2 rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm font-medium hover:bg-white/10 transition"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver
          </button>
          <button
            type="button"
            onClick={goHome}
            className="flex-1 inline-flex items-center justify-center gap-2 rounded-xl bg-white text-slate-950 px-4 py-3 text-sm font-semibold hover:bg-slate-100 transition"
          >
            <Home className="w-4 h-4" />
            Ir al inicio
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;


